import React from 'react';
import Burger from '../components/Burger';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="background-register slide-in-left-transition" style={{width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <div style={{maxWidth: '800px', background: '#eef6ff', padding: '20px',paddingBottom: '40px', borderRadius: '15px'}}>
<Burger />
      <img src="/repup.png"  alt="Price level" style={{ width: '130px'}} />
      <p>
        <strong>RePUP – Real-time Performance Upgrade of Buildings</strong>
        <br />
        <br />
        RePUP is an innovative four-year project, led by Climify and funded by Innovationsfonden, with a total budget of DKK 18.5 million. The project aims to revolutionize indoor climate management in buildings by integrating artificial intelligence, real-time data and smart energy solutions to improve comfort, reduce energy consumption and minimize environmental impact.        <br />
        <br />
        RePUP brings together leading research and industry partners, including DTU Sustain, DTU Compute, and DTU Skylab, together with Danfoss, VELUX, Panasonic, Enfor, Center Denmark, and the municipalities of Høje-Taastrup and Rudersdal.        <br />
        <br />
        As part of RePUP, we are demonstrating our solutions in five single-family homes and four large-scale sites, including schools, a kindergarten, an office, and two university buildings. Additionally, we are developing an educational video game that challenges players to balance comfort, costs, and CO₂ emissions by managing energy use in buildings.        <br />
        <br />
        🎮 Simulator credits: CLIMIFY, Nicolas Gelmini, Terion.
        <br />
        <br />
        🚀 Are you ready to optimize the future of energy? Join us and play!
      </p>
      </div>
      <button
          type="button"
          onClick={() => navigate("/")}
          aria-label="Go to homepage"
          style={{
            position: "absolute",
            top: '35px',
            background: "none",
            border: "none",
            padding: 0,
          }}
        >
          <img src="/neonlogo.png" alt="" style={{ width: "170px" }} />
        </button>
      <img src="/triade.png" alt="Price level" style={{ width: '55px', position: 'absolute', bottom: '35px' }} />
    </div>
  );
};

export default About;